export default __webpack_public_path__ + "static/media/triggers.cb0ab238.png";